import React from "react";
import termsData from "../data/terms-and-conditions.json";

function Terms() {
  return (
    <main className=" min-h-screen">
      <div className="pt-24 pb-16 sm:pt-28 sm:pb-20 lg:pt-32 lg:pb-24">
        
        {/* ================= DOCUMENT CONTAINER ================= */}
        <div className="section-container max-w-[880px]">
          
          {/* Header Card */}
          <div className="border-b border-[#e2eae5] pb-8 sm:pb-10 mb-8 sm:mb-12">
            <p className="font-jakarta text-[11px] font-semibold tracking-[0.34em] text-[var(--hero-green)] sm:text-[12px] uppercase mb-3">
              LEGAL DOCUMENT
            </p>
            <h1 className="font-bricolage text-[32px] sm:text-[42px] md:text-[48px] font-bold leading-[1.1] tracking-[-1px] text-[#111827]">
              {termsData.title}
            </h1>
            <p className="mt-3 font-jakarta text-[13.5px] sm:text-[14.5px] font-medium text-[#64748b]">
              Last Updated: {termsData.lastUpdated}
            </p>

            {/* Intro Paragraphs */}
            <div className="mt-6 space-y-4 font-jakarta text-[14.5px] sm:text-[15.5px] leading-[1.7] text-[#334155]">
              {termsData.intro.map((para, idx) => (
                <p key={idx}>{para}</p>
              ))}
            </div>
          </div>

          {/* Clauses / Sections */}
          <div className="space-y-10 sm:space-y-12">
            {termsData.sections.map((section) => (
              <section key={section.id} className="scroll-mt-24">
                
                {/* Heading */}
                <h2 className="font-bricolage text-[20px] sm:text-[24px] font-bold tracking-tight text-[#111827] border-b border-[#e2eae5] pb-2.5 mb-4">
                  {section.heading}
                </h2>

                {/* Intro text if present */}
                {section.introText && (
                  <p className="font-jakarta text-[14.5px] sm:text-[15.5px] leading-[1.7] text-[#334155] mb-3">
                    {section.introText}
                  </p>
                )}

                {/* Items list if present */}
                {section.items && (
                  <ul className="list-disc pl-5 space-y-2 font-jakarta text-[14px] sm:text-[15px] leading-[1.65] text-[#334155] mb-3">
                    {section.items.map((item, iIdx) => (
                      <li key={iIdx}>{item}</li>
                    ))}
                  </ul>
                )}

                {/* Paragraphs if present */}
                {section.paragraphs && (
                  <div className="space-y-3 font-jakarta text-[14.5px] sm:text-[15.5px] leading-[1.7] text-[#334155]">
                    {section.paragraphs.map((p, pIdx) => (
                      <p key={pIdx}>{p}</p>
                    ))}
                  </div>
                )}

                {/* Contact Card if present */}
                {section.contactCard && (
                  <div className="mt-4 rounded-xl border border-[#d8e4dc] bg-white p-5 sm:p-6 shadow-xs font-jakarta text-[14px] sm:text-[15px] leading-[1.6] text-[#334155]">
                    <p className="font-semibold text-[#111827]">{section.contactCard.company}</p>
                    <p className="mt-1 text-[#475569]">{section.contactCard.address}</p>
                    <p className="mt-2 text-[#475569]">
                      Email:{" "}
                      <a
                        href={`mailto:${section.contactCard.email}`}
                        className="font-medium text-[var(--hero-green)] hover:underline"
                      >
                        {section.contactCard.email}
                      </a>
                    </p>
                  </div>
                )}

              </section>
            ))}
          </div>

        </div>

      </div>
    </main>
  );
}

export default Terms;
